import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Visibility from '@mui/icons-material/Visibility';
import Insights from '@mui/icons-material/Insights';
import {
  BaseTableContainer,
  FakeButton,
  JobFitBadge,
  ScoreValue,
  ScoreWrapper,
  StyledTableCell,
  StyledTableRow,
} from './style';
import { brand } from 'themes/brand';

interface MockRow {
  candidateName: string;
  requestDate: string;
  status: 'em andamento' | 'finalizado';
  result: string;
  jobFitScore: number;
}

const rows: MockRow[] = [
  {
    candidateName: 'Ana Beatriz Ferreira',
    requestDate: '02/07/2026',
    status: 'em andamento',
    result: '...',
    jobFitScore: 92,
  },
  {
    candidateName: 'Lucas Andrade',
    requestDate: '01/07/2026',
    status: 'em andamento',
    result: '...',
    jobFitScore: 74,
  },
  {
    candidateName: 'Rafael Nogueira Costa',
    requestDate: '28/06/2026',
    status: 'finalizado',
    result: 'superior',
    jobFitScore: 86,
  },
  {
    candidateName: 'Camila Souza Lima',
    requestDate: '22/06/2026',
    status: 'finalizado',
    result: 'médio superior',
    jobFitScore: 58,
  },
];

const statusColor = (status: MockRow['status']) =>
  status === 'em andamento' ? brand.status.warning.bg : brand.status.success.bg;

const scoreTone = (score: number): 'success' | 'info' | 'danger' => {
  if (score >= 80) return 'success';
  if (score >= 60) return 'info';
  return 'danger';
};

export const ListingMock = () => {
  return (
    <BaseTableContainer>
      <Table
        sx={{ minWidth: 700 }}
        aria-label="prévia da listagem com coluna JobFit"
      >
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">Nome do candidato</StyledTableCell>
            <StyledTableCell align="center">Solicitação</StyledTableCell>
            <StyledTableCell align="center">Status</StyledTableCell>
            <StyledTableCell align="center">Resultado</StyledTableCell>
            <StyledTableCell align="center">
              JobFit{' '}
              <JobFitBadge>
                <AutoAwesome /> IA
              </JobFitBadge>
            </StyledTableCell>
            <StyledTableCell align="center" />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.candidateName}>
              <StyledTableCell align="center">
                {row.candidateName}
              </StyledTableCell>
              <StyledTableCell align="center">
                {row.requestDate}
              </StyledTableCell>
              <StyledTableCell align="center">
                <FakeButton variant={statusColor(row.status)}>
                  {row.status}
                </FakeButton>
              </StyledTableCell>
              <StyledTableCell align="center">{row.result}</StyledTableCell>
              <StyledTableCell align="center">
                <ScoreWrapper>
                  <ScoreValue tone={scoreTone(row.jobFitScore)}>
                    {row.jobFitScore}
                    <span>/100</span>
                  </ScoreValue>
                  <Tooltip title="Ver relatório de JobFit">
                    <Insights />
                  </Tooltip>
                </ScoreWrapper>
              </StyledTableCell>
              <StyledTableCell align="right">
                <Tooltip title="Ver detalhes da solicitação">
                  <Visibility />
                </Tooltip>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </BaseTableContainer>
  );
};
